<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OG3xfI/tc-custom/9781526732828.jpg?1704456353542" alt="This image is the cover for the book Spitfire!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Spitfire!
      </h1>
      <p class="bookDescription body article font2">
        <b>“A really excellent, detailed, comprehensive and moving history of 19 Squadron, RAF during the Second World War” from the author of <i>Arnhem 1944</i> (</b><b><i>Clash of Steel</i></b><b>).</b><br/>  <br/> As a child, Dilip Sarkar was fascinated by the haunting image of an anonymous RAF Spitfire pilot. Taken minutes after landing from a Battle of Britain combat, this was Squadron Leader Brian Lane DFC, the commander of 19 Squadron, based at Fowlmere. Deeply moving was the discovery that, in 1942, Brian was reported missing after a futile nuisance raid over the Dutch coast.<br/>  <br/> During the mid-1980s, Dilip began researching the life and times of both Brian Lane and 19 Squadron, forging close friendships with many of the unit’s surviving Battle of Britain pilots and support staff. Nearly thirty years later, sadly all of the survivors are now deceased, but Dilip’s close relationship has provided a huge archive of correspondence and interviews in addition to a unique photographic collection. Furthermore, the author, a retired police detective, has thoroughly investigated the life—and death—of Squadron Leader Lane.<br/>  <br/> This completely new <i>Spitfire! </i>covers everything we would ever need to know about such a unit during the critical pre and early war period: the social, political, aviation and military history all in one volume—emphasizing the human experience involved and the stories of casualties. With an immense photographic collection—many published here for the first time—this book is destined to become a classic.<br/>  <br/> “The most thorough book about any squadron in RAF service during the Battle of Britain . . . an impeccable source of information and a gripping story—Most Highly Recommended.” —Firetrench
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dilip Sarkar
      </h2>
      
      <p class="authorDescription body article">A prolific author, DILIP SARKAR has been obsessed with the Second World War for a lifetime. An MBE for &lsquo;services to aviation history&rsquo;, and Fellow of the Royal Historical Society, unsurprisingly, for a retired police detective with a First in Modern History, his work has always been evidence-based - often challenging long-accepted myths. Firmly focussed on the &lsquo;human&rsquo; experience of war, his many previous works include the authorized biographies of Group Captain Sir Douglas Bader and Air Vice-Marshal &lsquo;Johnnie&rsquo; Johnson, the best-selling Spitfire Manual and The Few. Dilip has presented at such prestigious venues as Oxford University, the Imperial War and RAF Museums, and National Memorial Arboretum; he works on TV documentaries, both on and off screen.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword/Air World
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7bbfb825